(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-collection-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.cartCollectionVariantsBound) {
    window.cartCollectionVariantsBound = true;
    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('.cart-collection__select')) return;
      const option = select.selectedOptions[0];
      const form = select.closest('.cart-collection__form');
      if (!option || !form) return;
      const price = form.querySelector('.cart-collection__price');
      const compare = form.querySelector('.cart-collection__compare');
      const button = form.querySelector('.cart-collection__add');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (button) button.disabled = option.dataset.available !== 'true';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
